import { postEE, fetchQuery } from '@general/api/shared';

export const url = '/api/carousel';
const fetchRequest = section => postEE({ endpoint: url, data: { section } });

export const getCarouselSlides = section => fetchQuery({ fetchRequest: () => fetchRequest(section) });
